<template>
    <div class="zuke_index">
        <div class="head_box">
            <div class="head_top_box">
                <div class="head_top">
                    <a href="javascript:history.back(-1)"><img src="../../assets/images/left.png" alt=""></a>
                    <h1>创建词条</h1>
                    <div class="head_top_btn"></div>
                </div>
            </div>
        </div>
        <!-- 声明 -->
        <div class="declare" v-if="guide_index == 0">
            <div class="guide">
                <div class="guide_title_box">
                    <h2 class="guide_title">创建词条引导</h2>
                    <div class="skip" @click="next(2)">跳过</div>
                    <div class="guide_tips">为了您更好的通过审核，请务必阅读租客百科的<span>创建须知</span></div>
                </div>
                <div class="guide_info">
                    <h3>一、声明</h3>
                    <div class="guide_tips">在正式创建词条前，首先请你承诺：</div>
                    <div class="declare_box">
                        <div class="declare_list">1、不在租客百科添加广告性质的内容， 如联系方式，   官方网站链接等；</div>
                        <div class="declare_list">2、不在租客百科编写涉及反动，违法犯罪，色情，暴力的内容；</div>
                        <div class="declare_list">3、不在租客百科编写虚假的、捏造的、恶搞的、缺乏根据的内容；</div>
                        <div class="declare_list">4、不侵犯他人合理权益；</div>
                        <div class="declare_list">5、接受违反以上规则时，租客账号会被封禁的结果。</div>
                    </div>
                </div>
                <div class="guide_btn">
                    <div class="occupy"></div>
                    <div class="guide_btn_list next" @click="next(1)">下一步</div>
                    <div class="occupy"></div>
                </div>
            </div>
        </div>
        <!-- 词条名 -->
        <div class="name" v-if="guide_index == 1">
            <div class="guide">
                <div class="guide_title_box">
                    <h2 class="guide_title">创建词条引导</h2>
                    <div class="skip" @click="next(2)">跳过</div>
                    <div class="guide_tips">为了您更好的通过审核，请务必阅读租客百科的<span>创建须知</span></div>
                </div>
                <div class="guide_info">
                    <h3>二、词条名</h3>
                    <div class="name_box">
                        <div class="name_list">
                            <img src="../../assets/images/name_tips.png" alt="">
                            <div class="name_text">请正确填写词条名，确保填写的词条名是真实存在的</div>
                        </div>
                        <div class="name_list">
                            <img src="../../assets/images/name_tips.png" alt="">
                            <div class="name_text">如果你的词条名已经存在，你可以选择继续创建，或者去编辑已有词条</div>
                        </div>
                    </div>
                </div>
                <div class="guide_btn">
                    <div class="occupy"></div>
                    <div class="guide_btn_list prior" @click="next(0)">上一步</div>
                    <div class="guide_btn_list next" @click="next(2)">下一步</div>
                    <div class="occupy"></div>
                </div>
            </div>
        </div>
        <!-- 开始创建 -->
        <div class="start" v-if="guide_index == 2">
            <div class="guide">
                <div class="guide_title_box">
                    <h2 class="guide_title">创建词条引导</h2>
                    <div class="guide_tips">为了您更好的通过审核，请务必阅读租客百科的<span>创建须知</span></div>
                </div>
                <div class="guide_info">
                    <h3>三、开始创建</h3>
                    <div class="start_tips">现在选择你要创建的词条类别，开始编辑你发词条内容吧！</div>
                    <div class="start_box">
                        <div class="start_list" v-for="(type,index) in type" @click="start_input(index)" :class="index == type_index ? 'active' : ''">
                            <div class="input"><p></p></div>
                            <div class="start_title">{{type}}</div>
                        </div>
                    </div>
                </div>
                <div class="guide_btn">
                    <div class="occupy"></div>
                    <div class="guide_btn_list prior" @click="next(1)">上一步</div>
                    <div class="guide_btn_list start_btn" @click="next(3)">开始创建</div>
                    <div class="occupy"></div>
                </div>
            </div>
        </div>
        <!-- 创建词条 -->
        <div class="fill_bg_box" v-if="guide_index == 3">
            <div class="fill">
                <div class="head_box"></div>
                <div class="fill_type">
                    <div class="fill_title">当前词条类型为：{{type_name}}</div>
                    <div class="fill_btn" @click="next(2)"><img src="../../assets/images/release/baike-again.png" alt="">重新选择</div>
                </div>
                <div class="fill_list" @click="city_show_btn">
                    <div class="fill_title">城市</div>
                    <div class="fill_list_btn">{{city}}<span>&gt;</span></div>
                </div>
                <div class="fill_list">
                    <div class="fill_title">词条名</div>
                    <input type="text" v-model.trim="fill_name" placeholder="请输入你要创建的品牌公寓词条">
                </div>
                <div class="add_btn" @click="name_test()">下一步</div>
            </div>
        </div>
        
        <!-- 词条弹框 -->
        <div class="tips_box" v-if="sn_index == 1">
            <div class="tips_fixed">
                <div class="tips_title">改词条名已存在，您可以</div>
                <div class="tips_btn">
                    <!-- <router-link :to="{name:'baike_detail',params:{sn:sn_text + '.html'}}" class="tips_btn_list">查看词条</router-link> -->
                    <div class="tips_btn_list" @click="detail_btn">查看词条</div>
                    <div class="tips_btn_list" @click="release_btn">编辑已有版本</div>
                </div>
            </div>
        </div>
        <!-- 城市选择 -->
        <cityBox v-show='city_show == 1' @func='cityBox'></cityBox>
    </div>
</template>

<script>
    import cityBox from './city.vue';
    export default {
        name: "baike_guide",
        data:()=>{
            return {
                // 显示步骤的控制索引
                guide_index:0,
                // 词条类别索引
                type_index:1,
                // 词条数组
                type:['小区类','企业类','商圈类','品牌公寓类','写字楼类','商业综合体/商铺类','企业孵化器类','物业公司类'],
                // 类别
                type_name:'企业',
                // 城市选择
                city:'深圳',
                // 判断城市选择显示隐藏
                city_show:0,
                // 显示城市编号
                city_num:103,
                // 词条名
                fill_name:'',
                // 控制弹框显示隐藏
                sn_index:0,
                sn_text:'',
            }
        },
        components:{
            cityBox
        },
        methods:{
            // 点击跳转到详情页
            detail_btn(){
                this.$router.push({
                    name:'baike_detail',
                    params:{
                        sn:this.sn_text + '.html',
                    }
                })
            },
            // 点击跳转到编辑
            release_btn(){
                var _this = this
                var getinfoData = _this.$publicObj.getSign('/baike/view/info', {
                    sn: this.sn_text,
                    number: this.$store.state.cookies.member_id,
                    token: this.$store.state.cookies.member_pass,
                },_this.$store.state);
                $.ajax({
                    url: 'https://japiv2.zuke.com/baike/view/info',
                    type: 'post',
                    data: getinfoData,
                    success: function(res) {
                        if(res.code == 10000){
                            _this.$router.push({
                                name:'baike_release',
                                query:{
                                    name:res.data.name,
                                    type:res.data.type,
                                    city:res.data.city,
                                    cityName:res.data.attribute.chengshi,
                                    sn:res.data.sn,
                                    entrance:2,
                                },
                            })
                        }
                    }
                })
                
            },
            // 点击切换类别
            start_input(num){
                this.type_index = num
                // 修改类别
                var name = this.type[num]
                this.type_name = name.replace('类','')
            },
            // 点击进入下一步
            next(num){
                this.guide_index = num
            },
            // 城市选择
            cityBox(data){
                this.city = data.name
                this.city_num = data.num
                this.city_show = 0
            },
            // 显示城市选择
            city_show_btn(){
                this.city_show = 1
            },
            // 验证词条名是否存在
            name_test(){
                var _this = this
                var type = '1000' + (parseInt(this.type_index) + 1)
                if(this.fill_name == ''){
                    _this.$router.push({
                        name:'baike_release',
                        query:{
                            name:_this.fill_name,
                            type:type,
                            city:_this.city_num,
                            cityName:_this.city,
                            entrance:1,
                        },
                    })
                    return false;
                }
                var getinfoData = _this.$publicObj.getSign('/baike/my/exist', {
                    city: this.city_num,
                    type: type,
                    name: this.fill_name,
                    number: this.$store.state.cookies.member_id,
                    token: this.$store.state.cookies.member_pass,
                },_this.$store.state);
                // console.log(getinfoData)
                $.ajax({
                    url: 'https://japiv2.zuke.com/baike/my/exist',
                    type: 'post',
                    data: getinfoData,
                    success: function(res) {
                        if(res.code == 10000){
                            _this.sn_text = res.data.sn
                            _this.sn_index = 1
                            _this.$forceUpdate()
                        } else if(res.code == 50000){
                            _this.$router.push({
                                name:'baike_release',
                                query:{
                                    name:_this.fill_name,
                                    type:type,
                                    city:_this.city_num,
                                    cityName:_this.city,
                                    entrance:1,
                                },
                            })
                        } else {
                            _this.$publicObj.layerFun('查询失败')
                        }
                    }
                })
            }
        },
        mounted() {
            if(this.$route.query.index){
                this.guide_index = this.$route.query.index
            }
        },
    }
</script>

<style scoped>
    .head_box {
        height: 1.877333rem;
    }
    
    .head_top_box {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 1.877333rem;
        z-index: 100;
    }
    
    .head_top {
        display: flex;
        width: 100%;
        min-width: 8rem;
        max-width: 16rem;
        margin: 0 auto;
        height: 1.877333rem;
        background-color: #fff;
        border-bottom: 1px solid #ddd;
    }
    
    .head_top a {
        display: block;
        width: 2.56rem;
        height: 1.877333rem;
    }
    
    .head_top a img {
        display: block;
        height: 1.28rem;
        margin: 0 auto;
        padding: 0.298666rem;
    }
    
    .head_top h1 {
        flex: 1;
        text-align: center;
        height: 1.877333rem;
        line-height: 1.877333rem;
        font-size: 0.768rem;
        color: #333;
        font-weight: 500;
    }
    
    .head_top .head_top_btn {
        display: block;
        width: 2.56rem;
        height: 1.877333rem;
    }
    
    
    
    
    /* 主体内容 */
    .guide {
        margin-top: 0.64rem;
    }
    
    .guide_title_box {
        display: flex;
        flex-wrap: wrap;
        margin: 0 0.512rem;
    }
    
    .guide_title_box .guide_title {
        flex: 1;
        font-size: 0.938666rem;
        font-weight: 400;
    }
    
    .guide_title_box .skip {
        font-size: 0.512rem;
        color: #3FABFA;
        text-decoration: underline;
        margin-top: 0.170666rem;
    }
    
    .guide_title_box .guide_tips {
        width: 100%;
        margin-top: 0.426666rem;
        margin-bottom: 1.066666rem;
        font-size: 0.512rem;
        color: #333;
    }
    
    .guide_title_box .guide_tips span {
        font-size: 0.512rem;
        color: #3FABFA;
        text-decoration: underline;
        margin-top: 0.170666rem;
    }
    
    .guide_info {
        height: 14.933333rem;
        padding: 0 0.682666rem 0;
        background-color: #FAFAFA;
        overflow: hidden;
        margin-bottom: 1.493333rem;
    }
    
    .guide_info h3 {
        color: #333;
        font-weight: 500;
        font-size: 0.725333rem;
        margin-top: 0.682666rem;
        margin-bottom: 0.426666rem;
    }
    
    .guide_info .guide_tips {
        font-size: 0.597333rem;
        color: #999;
        margin-bottom: 0.256rem;
    }
    
    /* 声明 */
    .declare_box .declare_list {
        font-size: 0.597333rem;
        color: #333;
        margin-bottom: 0.682666rem;
        text-align: justify;
    }
    
    /* 词条名 */
    .name_list {
        display: flex;
        margin-bottom: 0.981333rem;
    }
    
    .name_list img {
        width: 0.426666rem;
        height: 0.512rem;
        margin-right: 0.32rem;
        vertical-align: top;
        margin-top: 0.170666rem;
    }
    
    .name_list .name_text {
        font-size: 0.597333rem;
        color: #333;
        text-align: justify;
    }
    
    /* 开始创建 */
    .start_tips {
        color: #333;
        font-size: 0.597333rem;
        margin-bottom: 0.853333rem;
    }
    
    .start_box {
        display: flex;
        flex-wrap: wrap;
        margin: 0 0.853333rem;
    }
    
    .start_box .start_list {
        display: flex;
        align-items: center;
        width: 48%;
        height: 1.92rem;
    }
    
    .start_box .start_list:nth-child(2n) {
        margin-left: 4%;
    }
    
    .start_box .input {
        width: 0.597333rem;
        height: 0.597333rem;
        padding: 0.085333rem;
        border: 1px solid #999999;
        border-radius: 50%;
    }
    
    .start_box .input p {
        width: 100%;
        height: 100%;
        background-color: #fff;
        border-radius: 50%;
    }
    
    .start_box .active .input {
        border: 1px solid #3FABFA;
    }
    
    .start_box .active .input p {
        background-color: #3FABFA;
    }
    
    .start_box .start_title {
        height: 0.597333rem;
        line-height: 0.597333rem;
        font-size: 0.597333rem;
        color: #333;
        margin-left: 0.170666rem;
    }
    
    /* 底部 */
    .guide_btn {
        display: flex;
        width: 100%;
    }
    
    .guide_btn .occupy {
        flex: 1;
    }
    
    .guide_btn .guide_btn_list {
        width: 6.144rem;
        height: 1.706666rem;
        line-height: 1.706666rem;
        text-align: center;
        color: #fff;
        font-size: 0.682666rem;
        background-color: #3fabfa;
    }
    
    .guide_btn .guide_btn_list.prior {
        color: #999;
        background-color: #EEEEEE;
        margin-right: 1.024rem;
    }
    
    
    /* 创建词条 */
    .fill_bg_box {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
    }
    
    .fill {
        background-color: #F8F8F8;
        overflow-y: scroll;
        z-index: 99;
        width: 100%;
        height: 100%;
        min-width: 8rem;
        max-width: 16rem;
        margin: 0 auto;
    }
    
    .fill_type {
        display: flex;
        height: 2.133333rem;
        line-height: 2.133333rem;
        padding: 0 0.554666rem;
        margin: 0.682666rem 0;
        background-color: #fff;
    }
    
    .fill_type .fill_btn {
        color: #3fabfa;
        font-size: 0.512rem;
    }
    
    .fill_type .fill_btn img {
        width: 0.533333rem;
        height: 0.533333rem;
        vertical-align: middle;
        margin-right: 0.256rem;
    }
    
    .fill_title {
        flex: 1;
        font-size: 0.682666rem;
        color: #333;
    }
    
    .fill_list {
        display: flex;
        height: 2.133333rem;
        line-height: 2.133333rem;
        padding: 0 0.554666rem;
        background-color: #fff;
        border-bottom: 1px solid #eee;
    }
    
    .fill_list:nth-child(4) {
        border-bottom: 0;
    }
    
    .fill_list .fill_list_btn {
        font-size: 0.597333rem;
        color: #333;
    }
    
    .fill_list .fill_list_btn span {
        margin-left: 0.256rem;
    }
    
    .fill_list input {
        width: 8.533333rem;
        border: 0;
        color: #999;
        font-size: 0.597333rem;
        text-align: right;
    }
    
    .add_btn {
        display: block;
        height: 1.770666rem;
        line-height: 1.770666rem;
        font-size: 0.725333rem;
        color: #fff;
        text-align: center;
        margin: 2.816rem 1.216rem 0;
        background-color: #3fabfa;
    }
    
    
    /* 提示弹框 */
    .tips_box {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: rgba(0,0,0,.7);
        z-index: 200;
    }
    
    .tips_fixed {
        position: fixed;
        top: 50%;
        left: 50%;
        width: 12.714666rem;/* 298 */
        height: 5.76rem;/* 298 */
        margin: -2.88rem 0 0 -6.357333rem;
        background-color: #fff;
        border-radius: 0.426666rem;
    }
    
    .tips_title {
        width: 100%;
        height: 3.84rem;
        line-height: 3.84rem;
        text-align: center;
        color: #333;
        font-size: 0.682666rem;
    }
    
    .tips_btn {
        display: flex;
        width: 100%;
        height: 1.898666rem;
        border-top: 1px solid #eee;
    }
    
    .tips_btn_list {
        flex: 1;
        line-height: 1.898666rem;
        text-align: center;
        color: #3FABFA;
    }
    
    .tips_btn_list:first-child {
        color: #999;
        border-right: 1px solid #eee;
    }
</style>


// WEBPACK FOOTER //
// guide.vue